export const FILTER_APPLY_DEBOUNCE_TIME = 400;
export const CHECK_OVERDUE_INTERVAL_TIME = 30 * 1000;
export const NEW_APPOINTMENT_HIGHLIGHT_TIME = 3 * 60 * 1000;



// WEBPACK FOOTER //
// ./src/redux/dashboard/config.js